export class AttachedImage {
  id;
  name;
  path;
  url;
  created_at;
  updated_at;
}

/* "image": {

"id": 3,
"name": "christina-wocintechchat-com-7PHq2BCa7dM-unsplash.jpg",
"path": "images/christina-wocintechchat-com-7PHq2BCa7dM-unsplash.jpg",
"url": "http://localhost:8000/storage/images/christina-...-unsplash.jpg",
"created_at": "2020-08-28T15:03:07.000000Z",
"updated_at": "2020-08-28T15:03:07.000000Z"

*/
